import { jsx as o } from "react/jsx-runtime";
import { components as n } from "react-select";
const r = (t) => {
  var e;
  return /* @__PURE__ */ o(
    n.Input,
    {
      ...t,
      "data-testid": `${(e = t.selectProps) == null ? void 0 : e.name}-AutoCompleteInput`
    }
  );
};
export {
  r as default
};
